<div class="outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">
    <div>
      <span class="action-name">{{ action }}</span
      ><span class="records">({{ auditList?.TotalItems }} records found)</span>
    </div>
    <div class="input-wrapper">
      <div class="inpp">
        <label class="search-label" for="search">Search by</label>
        <select
          name="filterdropdown"
          class="groupdropdown drpdown"
          *ngIf="findOptions.length > 0"
          [(ngModel)]="searchField"
        >
          <ng-container *ngFor="let item of findOptions">
            <option [ngValue]="item">{{ item.label }}</option>
          </ng-container>
        </select>

        <input [(ngModel)]="searchValue" type="text" class="search-box" />
        <span class="clrbtn" (click)="clearSearchBox()">clear</span>
        <button class="search-btn" (click)="applyFilterByField()">
          <img alt="" class="search-img" src="{{ baseHref }}/assets/images/icon-search.svg" />
        </button>

        <span>
          <span class="date-range">Select Range:</span>
          <input
            class="fromdate"
            [ngModel]="fromDate | date: 'yyyy-MM-dd'"
            (ngModelChange)="fromDate = $event"
            type="date"
            name="fromDate"
            (change)="applySelectedDateRange()"
          />

          <input
            class="todate"
            [ngModel]="toDate | date: 'yyyy-MM-dd'"
            (ngModelChange)="toDate = $event"
            type="date"
            name="toDate"
            (change)="applySelectedDateRange()"
          />

          <input type="button" class="reset-btn" value="Reset" (click)="resetDateRange()" />
        </span>
      </div>

      <span class="column-hide" (click)="showHideColumns()">
        <img
          src="{{ baseHref }}/assets/images/icon-tab-eye.png"
          style="width: 1rem; height: 1rem; margin-top: -0.25rem"
        /><span class="hid-col">Show Hide Columns ({{ headercount.shown }}/{{ headercount.hidden }})</span></span
      >
    </div>

    <p-table
      [columns]="cols"
      [value]="this.auditList.Data"
      [lazy]="true"
      (onLazyLoad)="loadGetAudits($event)"
      dataKey="id"
      [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true"
      [rows]="10"
      [totalRecords]="totalRecords"
      [loading]="loading"
      selectionMode="single"
      [scrollable]="true"
      [style]="{ width: '100%' }"
      [scrollHeight]="innerHeight + 'vh'"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of cols">
            <th *ngIf="!col?.hide">
              {{ col.label }}
              <span class="fts">
                <span class="filter" *ngIf="col.showFilter" (click)="toggleCustomColumnFilter(col.name)">
                  <ng-container *ngIf="col.filterVals; else notSelected">
                    <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter-selected.png" />
                  </ng-container>
                  <ng-template #notSelected>
                    <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter.png" />
                  </ng-template>
                </span>

                <span class="sort" (click)="sortByColumn(col.name)">
                  <ng-container *ngIf="col.hasOwnProperty('isAsc'); else others">
                    <ng-container *ngIf="col.isAsc; else falseBlock">
                      <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-up.png" />
                    </ng-container>
                    <ng-template #falseBlock>
                      <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-down.png" />
                    </ng-template>
                  </ng-container>

                  <ng-template #others>
                    <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort.png" />
                  </ng-template>
                </span>
              </span>
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" style="height: 2.875rem">
          <ng-container *ngFor="let col of cols">
            <td *ngIf="!col?.hide">
              {{ col.type === 'date' ? (rowData[col.name] | custdate) : rowData[col.name] }}
              -
            </td>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
